$(document).ready(function () {
    $('.product-container .prod-content .tabs-content .tabs-panel').each(function () {
        var html = `<div class="content">${$(this).html()}</div>`;
        var id = $(this).attr('id');
        $('.product-container .prod-content .prod-accordion .tabs-title a').each(function () {
            $(this).attr('role', 'accordian');
            if ($(this).attr('href') == '#'+id) {
                $(this).after(html);
            }
        })
    })

    $('.learn_more').on('click', function(){
      window.location.href = $(this).attr('href');
    });
    $('.product-container .prod-content .tabs-content').remove();
    $('.product-container .prod-content .prod-accordion').removeClass('tabs');
    $('.product-container .prod-content .prod-accordion').removeAttr('data-responsive-accordion-tabs');
    $('.product-container .prod-content .prod-accordion').removeAttr('data-tabs');
    $('.product-container .prod-content .prod-accordion').removeAttr('role');
    $('.product-container .prod-content .accordion-container .prod-accordion .tabs-title > a[role="accordian"]').on('click', function (e){
        e.preventDefault();
        if($(this).parent().hasClass('is-active')) {
            $('.product-container .prod-content .accordion-container .prod-accordion .tabs-title').removeClass('is-active');
            $('.product-container .prod-content .accordion-container:last-child .prod-accordion .tabs-title').addClass('is-active');
        } else {
            $('.product-container .prod-content .accordion-container .prod-accordion .tabs-title').removeClass('is-active')
            $(this).parent().addClass('is-active');
        }
    })

    $('.popup_btn').on('click', function (e) {
        e.preventDefault();
        var id = $(this).data('target');
        $('.popup').removeClass('active');
        $(id).addClass('active');
    });
    $('.popup-header .close').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.popup').removeClass('active')
    })
    $('.popup').on('click', function (e) {
        e.preventDefault();
        if (e.target.closest('.popup-container') == null) {
            $(this).removeClass('active');
        }
    });
    var tabs_left = 3;
    var thumb_container_size = 90;
    $(document).on('click', ".product-container.upsell .product-images .PwzrGrid-container .PwzrGrid-item", function (e) {
        var tabs = $(this).parent().find('.PwzrGrid-item').length;
        var index = $(this).find('[role="button"]').attr('tabindex');
        if((thumb_container_size * tabs) > $('#pwzrswiper-wrapper').height()){
          if ($('.product-container.upsell .product-images .rio-hide-scrollbar').hasClass('bottom')) {
              var left_tabs= tabs - index;
              if (left_tabs <= tabs_left) {
                  console.log(left_tabs);
                  $('.product-container.upsell .product-images .rio-hide-scrollbar').removeClass("bottom");
                  $('.product-container.upsell .product-images .rio-hide-scrollbar').addClass("top");
              }
          } else if($('.product-container.upsell .product-images .rio-hide-scrollbar').hasClass('top')) {
              var left_tabs= index-1;
              if (left_tabs <= tabs_left) {
                  console.log(left_tabs);
                  $('.product-container.upsell .product-images .rio-hide-scrollbar').removeClass('top');
                  $('.product-container.upsell .product-images .rio-hide-scrollbar').addClass('bottom');
              }
          } else {
              var left_tabs= tabs - index;
              if (left_tabs <= tabs_left) {
                  console.log(left_tabs);
                  $('.product-container.upsell .product-images .rio-hide-scrollbar').addClass("top");
              }
          }
        }
        
    })
    $('#shopify-section-promotion-bar').each(function(){
        var time = $(this).find('.promotion-bar-slider').data('time') * 1000
        $(this).find('.promotion-bar-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            arrows: true,
            autoplay: true,
            autoplaySpeed: time,
            adaptiveHeight: true
        });
        var $promotion_bar = $(this).find('.promotion-bar');
        $('#shopify-section-header #promotion-bar').append($promotion_bar);
    });
    var $mega_menu = $('.mega-menu-container');
    $('#shopify-section-header').append($mega_menu);
});

$(document).on('click', '.popup .popup-container', function(e){
    e.preventDefault();
    console.log("asdfasdf")
    if ($(window).width() < 768 ) {
        $(this).toggleClass('zoom')
    }
});
